//MARCAS
export const urlGetVehicleBrands = "/api/vehicles-marca";
export const urlCreateVehicleBrand = "/api/vehicles-marca";
export const urlEditVehicleBrand = "/api/vehicles-marca";
